import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

import { PledgeItemInterface } from "@/types/pledgeService";

interface RenewState {
  selectedPledgeData: PledgeItemInterface | null;
  downloanAmount: number;
  cddInfo: any;
  cddType: string;

  setSelectedPledgeData: (data: PledgeItemInterface | null) => void;
  setDownloanAmount: (amount: number) => void;
  reset: () => void;
  update: (partial: Partial<RenewState>) => void;
}

const initialState = {
  selectedPledgeData: null,
  downloanAmount: 0,
  cddInfo: null,
  cddType: "",
};

export const useRenewStore = create<RenewState>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,

        setSelectedPledgeData: (data): void => set({ selectedPledgeData: data }),

        setDownloanAmount: (amount): void => set({ downloanAmount: amount }),

        reset: (): void => set(initialState),

        update: (partial): void =>
          set((state) => ({
            ...state,
            ...partial,
          })),
      }),
      {
        name: "renew-store",
      },
    ),
    {
      name: "RenewStore",
    },
  ),
);
